webpackJsonp([10],{

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__ = __webpack_require__(442);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcb3acf6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__ = __webpack_require__(621);
function injectStyle (ssrContext) {
  __webpack_require__(616)
}
var normalizeComponent = __webpack_require__(13)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bcb3acf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcb3acf6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_min_safe_integer__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_min_safe_integer__);


/* harmony default export */ __webpack_exports__["a"] = ({
  normal: {
    decimal: ',',
    thousands: '.',
    precision: 4,
    masked: false,
    allowBlank: false,
    min: 0
  },
  real: {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    precision: 4,
    masked: false,
    allowBlank: false,
    min: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_min_safe_integer___default.a,
    max: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a
  },
  percent: {
    decimal: ',',
    thousands: '.',
    suffix: ' %',
    precision: 4,
    masked: false,
    allowBlank: false,
    min: 0,
    max: 100
  }
});

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(188), __esModule: true };

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);









var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "products";

var ProductService = function () {
  function ProductService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ProductService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ProductService, null, [{
    key: 'validade',
    value: function validade(product) {
      var errors = [];
      if (!product.category) errors.push('categoria');
      if (!product.description) errors.push('descrição');
      if (!product.unity) errors.push('unidade de medida');
      if (!product.value) errors.push('valor unitário');

      if (errors.length > 0) return errors;else return null;
    }
  }, {
    key: 'getAll',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var products;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url);

              case 3:
                products = _context.sent;
                return _context.abrupt('return', products.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw _context.t0.response.data;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() // getAll()

  }, {
    key: 'getByCategory',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(type) {
        var products;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url + "/getByCategory", type);

              case 3:
                products = _context2.sent;
                return _context2.abrupt('return', products.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0.response.data;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function getByCategory(_x) {
        return _ref2.apply(this, arguments);
      }

      return getByCategory;
    }()
  }, {
    key: 'save',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(product) {
        var productSaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, product);

              case 3:
                productSaved = _context3.sent;
                return _context3.abrupt('return', productSaved.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0.response.data;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function save(_x2) {
        return _ref3.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: 'update',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(product) {
        var productUpdated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, product);

              case 3:
                productUpdated = _context4.sent;
                return _context4.abrupt('return', productUpdated.data);

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0.response.data;

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function update(_x3) {
        return _ref4.apply(this, arguments);
      }

      return update;
    }() // update()

  }, {
    key: 'remove',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(product) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url, {
                  data: product
                });

              case 3:
                _context5.next = 8;
                break;

              case 5:
                _context5.prev = 5;
                _context5.t0 = _context5['catch'](0);
                throw _context5.t0.response.data;

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 5]]);
      }));

      function remove(_x4) {
        return _ref5.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }]);

  return ProductService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (ProductService);

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(62);
__webpack_require__(61);
module.exports = __webpack_require__(189);


/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var get = __webpack_require__(66);
module.exports = __webpack_require__(3).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var MessageFormatterUtil = function () {
    function MessageFormatterUtil() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MessageFormatterUtil);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MessageFormatterUtil, null, [{
        key: 'formatErrorMessage',


        /**
         * Método para formatar mensagem de erro. 
         * O argumento deve ser um array onde a função construirá uma String formatada.
         * Basicamente o procedimento consiste em adicionar, no início da String, um artigo no singular,
         * e adicionar a String 'é obrigatório' ou 'são obrigatórios' no final.
         * @param {Array} errors 
         * @returns {String} errorMessage
         */
        value: function formatErrorMessage(errors) {
            if (!errors || !errors.length) return errors;
            if (errors.length == 1) return 'O(a) ' + errors.toString() + ' \xE9 obrigat\xF3rio';
            var errorMessage = 'O(a) ';
            for (var i = 0; i < errors.length; i++) {
                if (i == errors.length - 1) errorMessage += 'e ' + errors[i] + ' ';else if (i == errors.length - 2) errorMessage += errors[i] + ' ';else errorMessage += errors[i] + ', ';
            }
            errorMessage += 'são obrigatórios.';
            return errorMessage;
        }
    }]);

    return MessageFormatterUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (MessageFormatterUtil);

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(218), __esModule: true };

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(219);
module.exports = 0x1fffffffffffff;


/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(8);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(221), __esModule: true };

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(222);
module.exports = -0x1fffffffffffff;


/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(8);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration__ = __webpack_require__(59);









var url = __WEBPACK_IMPORTED_MODULE_5__configuration__["a" /* default */].apiHost + "productCategorys";

var ProductCategoryService = function () {
  function ProductCategoryService() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ProductCategoryService);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ProductCategoryService, null, [{
    key: 'validade',
    value: function validade(productCategory) {
      var errors = [];
      if (!productCategory.type) errors.push('tipo - categoria');
      if (!productCategory.description) errors.push('descrição');

      if (errors.length > 0) return errors;else return null;
    }
  }, {
    key: 'getAll',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var productCategorys;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url);

              case 3:
                productCategorys = _context.sent;
                return _context.abrupt('return', productCategorys.data);

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);
                throw _context.t0.response.data;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getAll() {
        return _ref.apply(this, arguments);
      }

      return getAll;
    }() // getAll()

  }, {
    key: 'save',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(productCategory) {
        var productCategorySaved;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, productCategory);

              case 3:
                productCategorySaved = _context2.sent;
                return _context2.abrupt('return', productCategorySaved.data);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0.response.data;

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 7]]);
      }));

      function save(_x) {
        return _ref2.apply(this, arguments);
      }

      return save;
    }() // save()

  }, {
    key: 'update',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(productCategory) {
        var productCategoryUpdated;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, productCategory);

              case 3:
                productCategoryUpdated = _context3.sent;
                return _context3.abrupt('return', productCategoryUpdated.data);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](0);
                throw _context3.t0.response.data;

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function update(_x2) {
        return _ref3.apply(this, arguments);
      }

      return update;
    }() // update()

  }, {
    key: 'remove',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(productCategory) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url, {
                  data: productCategory
                });

              case 3:
                _context4.next = 8;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4['catch'](0);
                throw _context4.t0.response.data;

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 5]]);
      }));

      function remove(_x3) {
        return _ref4.apply(this, arguments);
      }

      return remove;
    }() // remove()

  }]);

  return ProductCategoryService;
}(); // class


/* harmony default export */ __webpack_exports__["a"] = (ProductCategoryService);

/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_limit_string_length__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_limit_string_length___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_limit_string_length__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_MessageFormatterUtil_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__service_ProductService_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__service_ProductCategoryService_js__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Currency__ = __webpack_require__(178);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      value: 0,
      currency_config: __WEBPACK_IMPORTED_MODULE_7__utils_Currency__["a" /* default */].real,
      /**********\
      ***Rules***
      \**********/
      inputRules: [function (v) {
        return !!v || 'Campo obrigatório';
      }],
      categoryRules: [function (v) {
        return !!v || 'Selecione uma categoria';
      }],
      //CATEGORIAS //
      categories: [],
      products: [],

      // productsOffState: [],
      product: {},
      desactivationDialog: false,
      dialog: false,
      disabledButtonSave: false,
      headers: [{
        text: "Código",
        align: "center",
        value: "code"
      }, {
        text: "Especificação / Descrição",
        align: "center",
        value: "description"
      }, {
        text: "Marca",
        align: "center",
        value: "stamp"
      }, {
        text: "Unidade de Medida",
        align: "center",
        value: "unity",
        sortable: false
      }, {
        text: "Valor",
        align: "center",
        value: "value"
      }, {
        text: "Categoria",
        align: "center",
        value: "description"
      }, {
        text: "Situação",
        align: "center",
        value: "status",
        sortable: false
      }, {
        text: "Ação",
        align: "center",
        sortable: false
      }],
      loading: false,
      search: "",
      isEditing: false,
      index: undefined,

      /*********\
        ***Textos**
        \*********/
      desactivationDialogTitle: "Desativar Produto",
      emptyRecordsText: "Nenhum registro encontrado",

      emptySearchText: "Nenhum registro encontrado para",
      footerText: "Total de registros: ",
      loadingRecordsText: "Carregando registros...",
      title: "Produtos",
      snackbar: {
        visible: false,
        title: "",
        color: "",
        timeout: 6000
      }
    };
  },


  methods: {
    checkDuplicateRecord: function checkDuplicateRecord(product) {
      if (this.products.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.products), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var p = _step.value;

            if (p.description && p.stamp && p.description.toUpperCase() == product.description.toUpperCase() && p.stamp.toUpperCase() == product.stamp.toUpperCase()) return true;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return false;
    },
    showSnackbar: function showSnackbar(message, color) {
      this.snackbar.color = color;
      this.snackbar.title = message;
      this.snackbar.visible = true;
      this.snackbar.timeout = 6000;
    },
    //showSnackbar()

    closeDialog: function closeDialog() {
      this.$refs.form.reset();
      this.dialog = false;
    },
    initialize: function initialize() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.loading) _this.loading = true; //Se não estiver com o visual de carregamento, o ligar
                _context.prev = 1;

                if (_this.products.length < 1) _this.snackbar.visible = false;

                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5__service_ProductService_js__["a" /* default */].getAll();

              case 5:
                _this.products = _context.sent;
                //Receber os registros da API
                _this.savingproduct = false;
                _this.search = ""; //Limpar dados
                _this.dialog = false;
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                //Mandar o erro
                _this.showSnackbar("Erro ao carregar as Categorias de Produtos!", "error");
                console.log(_context.t0);

              case 15:
                _context.prev = 15;

                //Tirar o visual de carregamento
                _this.loading = false;
                return _context.finish(15);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 11, 15, 18]]);
      }))();
    },
    //initialize()

    getStringWithLimit: function getStringWithLimit() {
      if (this.product.technicalSpecification) this.product.technicalSpecification = __WEBPACK_IMPORTED_MODULE_3_limit_string_length___default()(this.product.technicalSpecification, 100, '');

      return '';
    },
    fillCategories: function fillCategories() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__service_ProductCategoryService_js__["a" /* default */].getAll();

              case 3:
                _this2.categories = _context2.sent;
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 6]]);
      }))();
    },
    addProduct: function addProduct() {
      this.fillCategories();
      this.product = new Object();
      this.dialog = true;
    },
    //addProduct()

    edit: function edit(item) {
      if (this.loading) return;
      this.fillCategories();
      this.isEditing = true;
      this.index = this.products.indexOf(item);
      this.product = this.products[this.index];
      this.product.value = item.value;
      this.dialog = true;
    },
    //edit()

    activateProduct: function activateProduct() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this3.desactivationDialog = false;
                _this3.savingproduct = true;
                _this3.product.active = true;
                _this3.dialog = false;
                _context3.next = 7;
                return _this3.save();

              case 7:
                _this3.showSnackbar("Ativado com sucesso!", "success");
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 10]]);
      }))();
    },
    //activateProduct()
    desactivateproduct: function desactivateproduct() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this4.desactivationDialog = false;
                _this4.product.active = false;
                _this4.dialog = false;
                _context4.next = 6;
                return _this4.save();

              case 6:
                _this4.showSnackbar("Desativado com sucesso!", "success");
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](0);

                console.log(_context4.t0);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 9]]);
      }))();
    },
    //desactivateproduct()
    save: function save() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var errors, msgSnackbar, type;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_this5.$refs.form.validate()) {
                  _context5.next = 39;
                  break;
                }

                if (!_this5.loading) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt('return');

              case 3:

                _this5.loading = true;
                errors = __WEBPACK_IMPORTED_MODULE_5__service_ProductService_js__["a" /* default */].validade(_this5.product);

                if (!errors) {
                  _context5.next = 9;
                  break;
                }

                _this5.showSnackbar(__WEBPACK_IMPORTED_MODULE_4__utils_MessageFormatterUtil_js__["a" /* default */].formatErrorMessage(errors), "error");
                _this5.loading = false;
                return _context5.abrupt('return');

              case 9:
                msgSnackbar = "";
                type = "";
                _context5.prev = 11;

                if (!_this5.product._id) {
                  _context5.next = 19;
                  break;
                }

                _context5.next = 15;
                return __WEBPACK_IMPORTED_MODULE_5__service_ProductService_js__["a" /* default */].update(_this5.product);

              case 15:
                msgSnackbar = "Produto Alterado com Sucesso!";
                type = "success";
                _context5.next = 28;
                break;

              case 19:
                if (!_this5.checkDuplicateRecord(_this5.product)) {
                  _context5.next = 24;
                  break;
                }

                msgSnackbar = "Registro Duplicado!";
                type = "error";
                _context5.next = 28;
                break;

              case 24:
                _context5.next = 26;
                return __WEBPACK_IMPORTED_MODULE_5__service_ProductService_js__["a" /* default */].save(_this5.product);

              case 26:
                msgSnackbar = "Produto Salvo com Sucesso!";
                type = "success";

              case 28:
                _this5.showSnackbar(msgSnackbar, type);
                _context5.next = 35;
                break;

              case 31:
                _context5.prev = 31;
                _context5.t0 = _context5['catch'](11);

                _this5.showSnackbar("Erro ao salvar o Produto", "error");
                console.log(_context5.t0);

              case 35:
                _context5.prev = 35;

                _this5.isEditing = false;
                _this5.initialize();
                return _context5.finish(35);

              case 39:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[11, 31, 35, 39]]);
      }))();
    },
    updateActivation: function updateActivation() {
      console.log("product " + this.product.active);
      console.log("DesativationDialog " + this.desactivationDialog);
      if (this.product.active) this.desactivationDialog = true;else this.activateProduct();
      //product.active  == true ? desactivationDialog = true : activateProduct()
    }
  }, //methods
  computed: {
    formTitle: function formTitle() {
      return this.product._id ? "Editar Produto" : "Novo Produto";
    },
    footerDynamicText: function footerDynamicText() {
      var text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
      return text;
    }
  }, //computed

  created: function created() {
    this.initialize();
  },
  //created()

  watch: {
    dialog: function dialog(value) {
      value || this.initialize();
    },


    desactivationDialog: function desactivationDialog() {
      if (!this.product) return;
      if (!this.product.hasOwnProperty("active")) return;
      if (this.product.active == undefined || null) return;
      if (this.savingproduct == true) {
        this.desactivationDialog = false;
      }
    } //watch
  } });

/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(617);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(155)("08111734", content, true, {});

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(154)(true);
// imports


// module
exports.push([module.i, "[data-v-bcb3acf6] .pt-switch{padding-top:20px}[data-v-bcb3acf6] .currency-prepend-outer-icon>.v-input__control>.v-input__slot>.v-input__prepend-inner>.v-input__icon--prepend-inner>.v-icon{background-color:#fff!important;position:absolute;padding:18px 5px;margin-right:14px}", "", {"version":3,"sources":["/vercel/path0/src/pages/Product.vue"],"names":[],"mappings":"AACA,6BACE,gBAAkB,CACnB,AACD,8IACE,gCAAmC,AACnC,kBAAmB,AACnB,iBAAkB,AAClB,iBAAmB,CACpB","file":"Product.vue","sourcesContent":["\n[data-v-bcb3acf6] .pt-switch {\n  padding-top: 20px;\n}\n[data-v-bcb3acf6] .currency-prepend-outer-icon>.v-input__control>.v-input__slot>.v-input__prepend-inner>.v-input__icon--prepend-inner>.v-icon {\n  background-color: white !important;\n  position: absolute;\n  padding: 18px 5px;\n  margin-right: 14px;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (str) {
    var limit = arguments.length <= 1 || arguments[1] === undefined ? 16 : arguments[1];
    var padString = arguments.length <= 2 || arguments[2] === undefined ? "#" : arguments[2];
    var padPosition = arguments.length <= 3 || arguments[3] === undefined ? "right" : arguments[3];

    if (typeof str !== "string" || typeof limit !== "number") {
        throw new Error("Invalid arguments specified");
    }

    // Calculate string length considering astral code points
    var strLength = (0, _length.length)(str);

    if (strLength > limit) {
        return (0, _unicodeSubstring2.default)(str, 0, limit);
    } else if (strLength < limit) {
        var padRepeats = padString.repeat(limit - strLength);
        return padPosition === "left" ? padRepeats + str : str + padRepeats;
    }
    return str;
};

var _unicodeSubstring = __webpack_require__(619);

var _unicodeSubstring2 = _interopRequireDefault(_unicodeSubstring);

var _length = __webpack_require__(620);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports["default"];

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function charAt(string, index) {
  var first = string.charCodeAt(index);
  var second;
  if (first >= 55296 && first <= 56319 && string.length > index + 1) {
    second = string.charCodeAt(index + 1);
    if (second >= 56320 && second <= 57343) {
      return string.substring(index, index + 2);
    }
  }
  return string[index];
}

function slice(string, start, end) {
  var accumulator = "";
  var character;
  var stringIndex = 0;
  var unicodeIndex = 0;
  var length = string.length;

  while (stringIndex < length) {
    character = charAt(string, stringIndex);
    if (unicodeIndex >= start && unicodeIndex < end) {
      accumulator += character;
    }
    stringIndex += character.length;
    unicodeIndex += 1;
  }
  return accumulator;
}

function toNumber(value, fallback) {
  if (value === undefined) {
    return fallback;
  } else {
    return Number(value);
  }
}

module.exports = function (string, start, end) {
  var realStart = toNumber(start, 0);
  var realEnd = toNumber(end, string.length);
  if (realEnd == realStart) {
    return "";
  } else if (realEnd > realStart) {
    return slice(string, realStart, realEnd);
  } else {
    return slice(string, realEnd, realStart);
  }
};

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.length = length;
// Borrowed from:
// https://github.com/lodash/lodash/blob/master/lodash.js
// https://github.com/mathiasbynens/regenerate
// https://mathiasbynens.be/notes/javascript-unicode
var astralRange = /\ud83c[\udffb-\udfff](?=\ud83c[\udffb-\udfff])|(?:[^\ud800-\udfff][\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]?|[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/g;

function length(str) {
    return str.match(astralRange).length;
}

/***/ }),

/***/ 621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',{staticClass:"font-weight-light"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Pesquisar","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading,"loading":_vm.loading,"color":_vm.loading ? 'info' : 'info',"icon":"","title":"Inserir um novo registro"},on:{"click":function($event){return _vm.addProduct();}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"loading":_vm.loading,"headers":_vm.headers,"search":_vm.search,"items":_vm.products,"rows-per-page-text":"Registros por Página","rows-per-page-items":[10, 30, 50, 100]},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.code))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.stamp))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.unity))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm._f("currency")(props.item.value)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.category ? props.item.category.description : ""))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('v-chip',{staticClass:"white--text font-weight-light",attrs:{"small":"","color":props.item.active == false ? 'error' : 'success lighten-1',"disabled":props.item.active == false}},[_vm._v("\n          "+_vm._s(props.item.active == false ? 'Inativo' : 'Ativo'))])],1),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0 text-xs-center"},[_c('v-btn',{attrs:{"icon":"","round":"","flat":"","title":"Editar","color":"info","disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.edit(props.item);}}},[_c('v-icon',{attrs:{"color":"info"}},[_vm._v("edit")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n      "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n    ")]}}])},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_c('strong',[_vm._v(" "+_vm._s(_vm.footerDynamicText)+" ")])]),_vm._v(" "),_c('div',{attrs:{"slot":"no-results","value":true},slot:"no-results"},[_c('h3',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.emptySearchText)+" \""+_vm._s(_vm.search)+"\".")])])],2),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","overlay":true,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.desactivationDialog),callback:function ($$v) {_vm.desactivationDialog=$$v},expression:"desactivationDialog"}},[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"card":""}},[_c('v-toolbar-title',{staticClass:"font-weight-light"},[_vm._v("\n        "+_vm._s(_vm.desactivationDialogTitle)+"\n      ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"color":"error","title":"Cancelar","icon":"","round":"","flat":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.desactivationDialog = false, _vm.product.active = true}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('p',[_vm._v("Ao desativar um equipamento você perderá a função de utilizá-la em outras áreas")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"success lighten-1","block":"","outline":"","round":""},on:{"click":_vm.desactivateproduct}},[_vm._v("Aceitar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{staticClass:"modal-size",attrs:{"persistent":"","max-width":"900px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.loading == false)?_c('v-card',[_c('v-toolbar',{staticClass:"elevation-1",attrs:{"color":"white"}},[_c('v-toolbar-title',{staticClass:"black--text font-weight-light"},[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[(_vm.product && _vm.product.active != undefined || null)?_c('v-switch',{staticClass:"pt-switch",attrs:{"pt-2":"","loading":_vm.loading,"label":_vm.product.active ? "Ativo" : "Inativo"},on:{"click":function($event){$event.preventDefault();_vm.product.active  == true ? _vm.desactivationDialog = true : _vm.activateProduct()}},model:{value:(_vm.product.active),callback:function ($$v) {_vm.$set(_vm.product, "active", $$v)},expression:"product.active"}}):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"title":"Cancelar","color":"error","icon":"","round":"","flat":""},on:{"click":_vm.closeDialog}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("clear")])],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-valiadtion":""}},[_c('v-layout',{attrs:{"wrap":"","row":""}},[(this.isEditing)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"code","box":"","label":"Código","disabled":""},model:{value:(_vm.product.code),callback:function ($$v) {_vm.$set(_vm.product, "code", $$v)},expression:"product.code"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":"Categoria do Produto","rules":_vm.categoryRules,"items":_vm.categories,"item-text":"description","prepend-icon":"assignment_turned_in","dense":"","return-object":"","solo":"","box":""},model:{value:(_vm.product.category),callback:function ($$v) {_vm.$set(_vm.product, "category", $$v)},expression:"product.category"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"label","rules":_vm.inputRules,"box":"","label":"Descrição","type":"text"},model:{value:(_vm.product.description),callback:function ($$v) {_vm.$set(_vm.product, "description", $$v)},expression:"product.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"copyright","label":"Marca","type":"text","box":""},model:{value:(_vm.product.stamp),callback:function ($$v) {_vm.$set(_vm.product, "stamp", $$v)},expression:"product.stamp"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"prepend-icon":"chrome_reader_mode","label":"Especificação Técnica","type":"text","counter":"500","rows":"5","no-resize":"","box":""},on:{"keyup":_vm.getStringWithLimit},model:{value:(_vm.product.technicalSpecification),callback:function ($$v) {_vm.$set(_vm.product, "technicalSpecification", $$v)},expression:"product.technicalSpecification"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"ac_unit","box":"","rules":_vm.inputRules,"label":"Unidade de Medida","type":"text"},model:{value:(_vm.product.unity),callback:function ($$v) {_vm.$set(_vm.product, "unity", $$v)},expression:"product.unity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-currency-field',_vm._b({staticClass:"currency-prepend-outer-icon",attrs:{"box":"","prependInnerIcon":"attach_money","label":"Valor Unitário (R$)"},model:{value:(_vm.product.value),callback:function ($$v) {_vm.$set(_vm.product, "value", $$v)},expression:"product.value"}},'v-currency-field',_vm.currency_config,false))],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"success lighten-1","round":"","block":"","disabled":_vm.disabledButtonSave},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.save();}}},[_vm._v("\n            Salvar")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.snackbar.color,"multi-line":"","timeout":_vm.snackbar.timeout,"vertical":"","right":"","button":""},model:{value:(_vm.snackbar.visible),callback:function ($$v) {_vm.$set(_vm.snackbar, "visible", $$v)},expression:"snackbar.visible"}},[_c('strong',[_vm._v(_vm._s(_vm.snackbar.title))]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.snackbar.visible = false}}},[_vm._v("\n      Fechar\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.5c85b7a7f14e475562f8.js